"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Parameter = void 0;
var Parameter = /** @class */ (function () {
    function Parameter(variable, range, required, description) {
        this.variable = variable;
        this.range = range;
        this.required = required;
        this.description = description;
    }
    return Parameter;
}());
exports.Parameter = Parameter;
//# sourceMappingURL=Parameter.js.map